/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source SVG file at
 * `src/shared/joykit/packages/core/icons/svgs/<SIZE>/tip.svg`, and run `yarn icon:codegen` to regenerate this file.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Tip',
  definitions: {
    '32': {
      viewBox: '0 0 32 32',
      path: (
        <>
          <path d="M16 .067a.6.6 0 0 1 .6.6V3.7a.6.6 0 0 1-1.2 0V.667a.6.6 0 0 1 .6-.6Z" fill="currentColor" />{' '}
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.02 7.058a8.824 8.824 0 0 0-5.077 1.594 8.88 8.88 0 0 0-3.25 4.228 8.92 8.92 0 0 0-.249 5.333 8.891 8.891 0 0 0 2.84 4.515l.007.005a3.403 3.403 0 0 1 1.237 2.587v4.157c0 .65.257 1.275.716 1.736.46.46 1.082.72 1.733.72h4.043c.652 0 1.276-.26 1.735-.721.46-.462.717-1.088.717-1.74v-4.156c0-.543.08-.868.317-1.383.21-.454.516-.857.897-1.18a8.89 8.89 0 0 0 2.86-4.501 8.92 8.92 0 0 0-.225-5.334 8.882 8.882 0 0 0-3.23-4.243 8.824 8.824 0 0 0-5.07-1.617ZM19.272 28.6v.873c0 .335-.132.656-.367.892a1.248 1.248 0 0 1-.885.368h-4.043c-.33 0-.648-.131-.882-.367a1.261 1.261 0 0 1-.367-.89V28.6h6.544Zm0-1.2v-1.791h-6.544V27.4h6.544Zm.086-2.991c.068-.322.18-.627.342-.979a4.63 4.63 0 0 1 1.211-1.593l.002-.001a7.69 7.69 0 0 0 2.474-3.894 7.72 7.72 0 0 0-.195-4.617 7.682 7.682 0 0 0-2.794-3.67 7.624 7.624 0 0 0-8.767-.02 7.68 7.68 0 0 0-2.81 3.657 7.72 7.72 0 0 0-.216 4.616 7.69 7.69 0 0 0 2.453 3.903 4.603 4.603 0 0 1 1.57 2.598h6.73Z"
            fill="#7139BF"
          />
          <path
            d="M6.058 2.86a.6.6 0 0 1 .837.135L8.671 5.45a.6.6 0 1 1-.972.703L5.923 3.7a.6.6 0 0 1 .135-.838ZM1.52 11.184a.6.6 0 1 0-.373 1.14l2.874.938a.6.6 0 0 0 .372-1.14l-2.873-.938ZM4.777 19.303a.6.6 0 0 1-.384.757l-2.873.938a.6.6 0 1 1-.373-1.141l2.874-.938a.6.6 0 0 1 .756.384ZM27.98 18.92a.6.6 0 0 0-.372 1.14l2.873.938a.6.6 0 1 0 .372-1.141l-2.873-.938ZM31.237 11.568a.6.6 0 0 1-.384.756l-2.873.938a.6.6 0 0 1-.372-1.14l2.873-.938a.6.6 0 0 1 .756.384ZM26.077 3.699a.6.6 0 0 0-.972-.704L23.33 5.45a.6.6 0 0 0 .973.703L26.077 3.7Z"
            fill="currentColor"
          />
        </>
      )
    }
  }
};

const icon = createSvgIcon(config);
export default icon;
